// FAQ pairs displayed in the blog article and used to build the FAQPage
// JSON-LD payload. Shared source so the visible text and the structured data
// can never drift apart.
export const PACTE_MIGRATOIRE_FAQ = [
  {
    q: "À quelle date le pacte migratoire européen est-il entré en application ?",
    a: "Le 12 juin 2026, dans les vingt-sept États membres.",
  },
  {
    q: "Combien de textes composent le pacte ?",
    a: "Dix règlements, qui couvrent le filtrage aux frontières, les procédures d'asile, la responsabilité des demandes et la solidarité entre États.",
  },
  {
    q: "En quoi consiste le mécanisme de solidarité ?",
    a: "Chaque État choisit entre trois options, accueillir une part des demandeurs d'asile, verser une contribution d'environ 20 000 euros par personne non accueillie ou fournir un appui opérationnel.",
  },
  {
    q: "La Pologne applique-t-elle le pacte ?",
    a: "Elle reprend les volets sécuritaires mais refuse la relocalisation. Elle a obtenu une exemption d'accueil, qui reste annuelle et révisable.",
  },
  {
    q: "Pourquoi la Pologne demande-t-elle cette exemption ?",
    a: "Elle invoque sa frontière avec la Biélorussie, où la migration serait instrumentalisée, et l'accueil de centaines de milliers de réfugiés ukrainiens depuis 2022.",
  },
  {
    q: "Qu'est-ce que la loi polonaise suspendant le droit d'asile ?",
    a: "Une loi de 2025 qui permet de suspendre temporairement les demandes d'asile à la frontière biélorusse, pour 60 jours renouvelables, avec des exceptions pour les personnes vulnérables.",
  },
  {
    q: "Cette suspension est-elle contestée ?",
    a: "Oui. Le HCR, Human Rights Watch, Amnesty et la Fondation Helsinki y voient une atteinte au non-refoulement. Le gouvernement, un commissaire européen et un tribunal de Białystok la jugent justifiée, cette dernière décision n'étant pas définitive.",
  },
  {
    q: "Le pacte change-t-il quelque chose si je m'installe légalement en Pologne ?",
    a: "Non. Il vise les arrivées irrégulières et l'asile aux frontières, pas la voie du visa, du permis et du titre de séjour.",
  },
];
